import React from 'react';

import SourceSetReport from '../../../../../Report';

import {
    IReportSet,
    IReportSetHeader,
} from '../../../../../../../../state/types';
import EventHeader from '../../../EventHeader';

interface IOwnProps {
    sourceSetElementReportSet: IReportSet;
    getHeaderName?: (header: IReportSetHeader) => string;
}

type TProps = IOwnProps;

const SourceSetElement = ({
    sourceSetElementReportSet,
    getHeaderName,
}: TProps) => {
    if (!sourceSetElementReportSet) {
        return null;
    }

    const header =
        sourceSetElementReportSet._meta &&
        sourceSetElementReportSet._meta.header;

    return (
        <React.Fragment>
            {header && (
                <EventHeader header={header} getHeaderName={getHeaderName} />
            )}

            {sourceSetElementReportSet.reports.map((report, index) => (
                <SourceSetReport key={index} report={report} />
            ))}
        </React.Fragment>
    );
};

export default SourceSetElement;
